module.exports = "/static/assets/d976c682d8eb881e64c715933175133b.png";